import { Stack } from "@mui/material";
import { useTu } from "@src/appV2/i18n/useTu";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { ResponsiveDialog } from "@src/appV2/redesign/components/ResponsiveDialog";
import { Text } from "@src/appV2/redesign/components/Text";
import { type UseModalState } from "@src/lib/ui-react";

interface Props {
  modalState: UseModalState;
  onSetUp: () => void;
  onDismiss: () => void;
}

export function PasskeySetupPromptDialog(props: Props) {
  const { modalState, onSetUp, onDismiss } = props;
  const { tu } = useTu("login");

  return (
    <ResponsiveDialog
      dismissible={false}
      showCloseButton
      modalState={modalState}
      onClose={onDismiss}
      title={tu("Set up a passkey")}
      footerContent={
        <DialogFooter
          layout="vertical"
          primaryAction={{ label: tu("Set up a passkey"), onClick: onSetUp }}
        />
      }
    >
      <Stack spacing={3}>
        <Text variant="body1">
          {tu(
            "Use your fingerprint, face, or device screen lock to sign in faster and more securely — no password or email link needed."
          )}
        </Text>
        <Text variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary })}>
          {tu("Only set up a passkey on a device that's yours, not a shared or public device.")}
        </Text>
      </Stack>
    </ResponsiveDialog>
  );
}
